import config from "environment";
import { getRequest, postRequest } from "./client";
import {
  PublicCollection
} from "winslow-core";

const { baseApi } = config;

export async function apiGetPublicCollection(id: string): Promise<PublicCollection | null> {
  const fetchURL = `${baseApi}/public-collections/${id}`;
  return await getRequest(fetchURL, "API/apiGetPublicCollection");
}

export async function apiGetPublicCollections(): Promise<PublicCollection[] | null> {
  const fetchURL = `${baseApi}/public-collections`;
  return await getRequest(fetchURL, "API/apiGetPublicCollections");
}

export async function apiRequestPublicCollection(url: string): Promise<boolean | null> {
    const fetchURL = `${baseApi}/public-collections/request/${url}`;
    return await getRequest(fetchURL, "API/apiRequestPublicCollection");
  }
